import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Mail, Lock, User, Shield, UserPlus } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function Register() {
    const { register } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: "", password: "", full_name: "" });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            await register(form.email, form.password, form.full_name);
            navigate("/ho-so", { replace: true });
        } catch (err) {
            setError(formatApiError(err.response?.data?.detail) || err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="pt-24 pb-12 min-h-screen relative overflow-hidden">
            <div className="absolute inset-0 bg-grid opacity-30" />
            <div className="container-x relative max-w-md">
                <div className="text-center mb-8 fade-up">
                    <Shield className="w-12 h-12 text-[var(--gold-deep)] mx-auto mb-3" />
                    <h1 className="font-heading text-3xl font-bold">Đăng ký tham gia</h1>
                    <p className="text-slate-500 text-sm mt-2">Trở thành thí sinh trên hệ thống quốc gia</p>
                </div>

                <form onSubmit={onSubmit} className="card p-8 space-y-4 fade-up delay-1">
                    <div>
                        <label className="block text-xs uppercase tracking-widest text-slate-500 mb-2">Họ và tên</label>
                        <div className="relative">
                            <User className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                            <input required value={form.full_name} onChange={(e) => setForm({ ...form, full_name: e.target.value })}
                                className="input pl-10" placeholder="Nguyễn Văn A" data-testid="full-name-input" />
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs uppercase tracking-widest text-slate-500 mb-2">Email</label>
                        <div className="relative">
                            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                            <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
                                className="input pl-10" placeholder="email@example.com" data-testid="email-input" />
                        </div>
                    </div>
                    <div>
                        <label className="block text-xs uppercase tracking-widest text-slate-500 mb-2">Mật khẩu</label>
                        <div className="relative">
                            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-500" />
                            <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
                                className="input pl-10" placeholder="Tối thiểu 6 ký tự" data-testid="password-input" />
                        </div>
                    </div>

                    {error && <div className="text-red-400 text-sm bg-red-400/10 border border-red-400/30 rounded-lg p-3" data-testid="register-error">{error}</div>}

                    <button type="submit" disabled={loading} className="w-full btn-primary" data-testid="register-submit-btn">
                        <UserPlus className="w-4 h-4" /> {loading ? "Đang tạo tài khoản…" : "Tạo tài khoản"}
                    </button>

                    <div className="text-center text-sm text-slate-500">
                        Đã có tài khoản? <Link to="/dang-nhap" className="text-[var(--gold-deep)] hover:underline" data-testid="link-login">Đăng nhập</Link>
                    </div>
                </form>
            </div>
        </main>
    );
}
